<template>
  <v-scale-screen width="1920" height="1080" fullScreen>
  <div class="dish-management">
    <!-- 顶部导航栏 -->
    <div class="header">
      <!-- 左侧品牌区 -->
      <div class="header-left">
        <div class="brand">
          <div class="stall-icon">
            <i class="el-icon-food"></i>
          </div>
          <div class="brand-text">
            <span class="header-title">菜品数量管理</span>
            <span class="header-subtitle">DISH STOCK MANAGEMENT</span>
          </div>
        </div>
      </div>

      <!-- 中间选择区 -->
      <div class="header-center">
        <div class="header-selects">
          <div class="select-item">
            <!-- <span class="select-label">
              <i class="el-icon-shop"></i> 档口
            </span> -->
            <el-select
              v-model="stallName"
              placeholder="请选择档口"
              class="header-select"
              @change="handleStallChange"
            >
              <el-option
                v-for="item in stallList"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>
          <div class="select-item">
            <!-- <span class="select-label">
              <i class="el-icon-dish"></i> 餐次
            </span> -->
            <el-select
              v-model="mealName"
              placeholder="请选择餐次"
              class="header-select"
              @change="handleMealChange"
            >
              <el-option
                v-for="item in mealList"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>

      <!-- 右侧信息与操作区 -->
      <div class="header-right">
        <div class="header-info">
          <span class="info-item">
            <i class="el-icon-date"></i>
            {{ currentDate }} {{ currentWeekday }}
          </span>
          <span class="info-item meal">
            <i class="el-icon-utensils"></i>
            {{ mealName }}<template v-if="mealTime">（{{ mealTime }}）</template>
          </span>
        </div>
        <div class="header-actions">
          <el-button type="text" class="header-btn" @click="handleRefresh">
            <i class="el-icon-refresh"></i> 刷新
          </el-button>
          <el-button type="text" class="header-btn logout-btn" @click="handleLogout">
            <i class="el-icon-switch-button"></i> 退出
          </el-button>
        </div>
      </div>
    </div>

    <!-- 菜品卡片列表（菜品多时可通过左右箭头滚动显示） -->
    <div class="dish-cards-wrapper">
      <div class="scroll-arrow left" @click="scrollDishCards('left')" v-if="dishList.length > 3">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="dish-cards" ref="dishCards">
        <div
          v-for="(dish, index) in dishList"
          :key="index"
          class="dish-card"
          :class="{ active: selectedDishIndex === index, 'sold-out': dish.sold_out === 1 }"
          @click="selectDish(index)"
        >
          <div class="dish-img">
            <img :src="dish.image" :alt="dish.name" />
            <!-- 售罄遮罩：sold_out === 1 时显示 -->
            <div class="sold-out-mask" v-if="dish.sold_out === 1">
              <span class="sold-out-text">售罄</span>
            </div>
          </div>
          <div class="dish-info">
            <div class="dish-name">
              {{ dish.name }}
              <span class="sold-out-tag" v-if="dish.sold_out === 1">已售罄</span>
            </div>
            <div class="dish-stats">
              <div class="stat-item">
                <span class="stat-value">{{ dish.total }}</span>
                <span class="stat-label">总数量</span>
              </div>
              <div class="stat-item">
                <span class="stat-value sold">{{ dish.sold }}</span>
                <span class="stat-label">已售</span>
              </div>
              <div class="stat-item">
                <span class="stat-value remaining">{{ dish.remaining }}</span>
                <span class="stat-label">剩余</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="scroll-arrow right" @click="scrollDishCards('right')" v-if="dishList.length > 3">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>

    <!-- 调整区域 -->
    <div class="adjust-section">
      <!-- 左侧：调整已售数量 -->
      <div class="adjust-panel">
        <div class="panel-title">调整已售数量</div>
        <div class="buttons-grid-wrapper">
          <div class="buttons-grid" ref="soldButtons">
            <div
              v-for="(btn, index) in soldButtons"
              :key="'sold-' + index"
              class="adjust-btn sold-btn"
              :class="{ 'is-disabled': isSelectedDishSoldOut }"
              @click="!isSelectedDishSoldOut && adjustSold(btn.value)"
            >
              {{ btn.label }}
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧：设置剩余数量 -->
      <div class="adjust-panel">
        <div class="panel-title">设置剩余数量</div>
        <div class="buttons-grid-wrapper">
          <div class="buttons-grid" ref="remainButtons">
            <div
              v-for="(btn, index) in filteredRemainButtons"
              :key="'remain-' + index"
              class="adjust-btn remain-btn"
              @click="setRemaining(btn.value)"
            >
              {{ btn.label }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部操作栏 -->
    <div class="footer">
      <div class="footer-left">
        <div class="tip-icon">💡</div>
        <span class="tip-label">操作提示</span>
        <span class="tip-text">点击蓝色按钮调整已售数量，点击绿色按钮设置剩余数量</span>
      </div>
      <div class="footer-right">
        <el-button class="sold-out-btn" type="danger" @click="handleSoldOut">
          <i class="el-icon-warning"></i> 售罄
        </el-button>
      </div>
    </div>
  </div>
  </v-scale-screen>
</template>

<script>
import { getStallAndMeal,getTodayDishes,sellDish,setSoldOut,restoreDish } from '../api/api'

export default {
  name: 'DishManagement',
  data() {
    return {
      // 档口 / 餐次
      stallList: [],
      mealList: [],
      // 从本地读取上次选择（无则按时间取默认餐次）
      stallName: sessionStorage.getItem('stall_name') || '',
      mealName: sessionStorage.getItem('meal_name') || '',
      mealTime: '',
      // 日期默认取当天（getTodayDishes 不传 date 时后端也按当天返回）
      currentDate: (() => {
        const d = new Date()
        const m = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        return `${d.getFullYear()}-${m}-${day}`
      })(),
      currentWeekday: '星期' + '日一二三四五六'.charAt(new Date().getDay()),
      // 默认图片：菜品 image 为空时兜底
      defaultImage:
        'https://shuwangysa.oss-cn-hangzhou.aliyuncs.com/uploads/20260819/ec502ef7265a0998b3672eab19618627.png',
      selectedDishIndex: 0,
      // 当前选中菜品名称（点击卡片时更新，随 sellDish 传给后端）
      selectedDishName: '',
      dishList: [],
      soldButtons: [
        { label: '-1', value: -1 },
        { label: '-2', value: -2 },
        { label: '-3', value: -3 },
        { label: '-4', value: -4 },
        { label: '-5', value: -5 },
        { label: '-6', value: -6 },
        { label: '-7', value: -7 },
        { label: '-8', value: -8 },
        { label: '-9', value: -9 },
        { label: '-10', value: -10 },
        { label: '-15', value: -15 },
        { label: '-20', value: -20 },
        { label: '-30', value: -30 },
        { label: '-50', value: -50 }
      ],
      remainButtons: [
        { label: '恢复', value: 'restore' },
        { label: '120', value: 120 },
        { label: '90', value: 90 },
        { label: '80', value: 80 },
        { label: '70', value: 70 },
        { label: '60', value: 60 },
        { label: '50', value: 50 },
        { label: '40', value: 40 },
        { label: '30', value: 30 },
        { label: '20', value: 20 },
        { label: '10', value: 10 },
        { label: '5', value: 5 },
        { label: '4', value: 4 },
        { label: '3', value: 3 },
        { label: '2', value: 2 },
        { label: '1', value: 1 }
      ]
    }
  },
  computed: {
    // 当前选中的菜品是否售罄
    isSelectedDishSoldOut() {
      const dish = this.dishList[this.selectedDishIndex]
      return !!(dish && dish.sold_out === 1)
    },
    // 设置剩余数量按钮：数值大于当前菜品总数量的不显示
    filteredRemainButtons() {
      const dish = this.dishList[this.selectedDishIndex]
      const total = dish ? dish.total : 0
      return this.remainButtons.filter(
        (btn) => btn.value === 'restore' || btn.value <= total
      )
    }
  },
  methods: {
    // 获取档口和餐次选项（后端返回，失败时保留 mock 兜底）
    async getStallAndMealData() {
      try {
        const res = await getStallAndMeal({
          shop_id: sessionStorage.getItem('shop_id') || null
        })
        console.log(res, 'getStallAndMeal')
        const biz = res && res.data && res.data.data
        if (!biz) return

        // 档口列表：后端 item 结构 { id, sort_order, stall_name }
        const stalls = Array.isArray(biz.stalls) ? biz.stalls : []
        if (stalls.length) {
          // 按 sort_order 升序排列
          const sorted = stalls.slice().sort(
            (a, b) => (a.sort_order || 0) - (b.sort_order || 0)
          )
          this.stallList = sorted.map((s) => s.stall_name)
        }

        // 餐次列表：后端 item 结构 { id, meal_name, sort_order }
        const meals = Array.isArray(biz.meals) ? biz.meals : []
        if (meals.length) {
          // 按 sort_order 升序排列；后端无时间字段，time 留空
          const sorted = meals.slice().sort(
            (a, b) => (a.sort_order || 0) - (b.sort_order || 0)
          )
          this.mealList = sorted.map((m) => ({
            id: m.id,
            name: m.meal_name,
            time: m.meal_time || m.time || ''
          }))
        }

        // 档口：优先取本地保存的选择，否则默认第一个
        if (this.stallList.length) {
          this.stallName = this.stallList.includes(this.stallName)
            ? this.stallName
            : this.stallList[0]
        }

        // 餐次：优先本地保存 → 其次按当前时间默认 → 再取第一个
        if (this.mealList.length) {
          const mealNames = this.mealList.map((m) => m.name)
          const defaultMeal = this.getDefaultMeal()
          let mealName = ''
          if (mealNames.includes(this.mealName)) {
            mealName = this.mealName
          } else if (defaultMeal && mealNames.includes(defaultMeal)) {
            mealName = defaultMeal
          } else {
            mealName = this.mealList[0].name
          }
          this.mealName = mealName
          const target = this.mealList.find((m) => m.name === mealName)
          this.mealTime = (target && target.time) || ''
        }

        // 选中后同步到本地，便于刷新后恢复
        if (this.stallName) sessionStorage.setItem('stall_name', this.stallName)
        if (this.mealName) sessionStorage.setItem('meal_name', this.mealName)

        // 档口/餐次确定后，加载对应菜品数据
        this.getTodayDishesData()
      } catch (e) {
        console.error('获取档口餐次失败：', e)
      }
    },
    // 获取今日菜品（参数 shop_id、stall_name、meal_name、date 可不传取当天）
    async getTodayDishesData() {
      try {
        const params = {
          shop_id: sessionStorage.getItem('shop_id') || null,
          stall_name: this.stallName || null,
          meal_name: this.mealName || null,
          date:this.currentDate
        }
        const res = await getTodayDishes(params)
        console.log(res, 'getTodayDishes')
        const biz = res && res.data && res.data.data
        if (!biz) return

        // 后端菜品数组 dishes（每项 { dish_name, image, initial_quantity, price,
        // remaining_quantity, sold_out, sold_quantity, stock_record_id }）
        // 映射为页面使用的 dishList 结构
        const dishes = biz.dishes
        if (Array.isArray(dishes) && dishes.length) {
          this.dishList = dishes.map((d) => ({
            name: d.dish_name || d.name || '未知菜品',
            image: d.image || this.defaultImage,
            // initial_quantity：总数量
            total: d.initial_quantity != null ? d.initial_quantity : 0,
            // sold_quantity：售卖数量
            sold: d.sold_quantity != null ? d.sold_quantity : 0,
            // remaining_quantity：剩余数量
            remaining:
              d.remaining_quantity != null ? d.remaining_quantity : 0,
            // sold_out：1 表示售罄
            sold_out: d.sold_out
          }))
          this.selectedDishIndex = 0
          // 默认选中第一个菜品，同步名称
          if (this.dishList.length) {
            this.selectedDishName = this.dishList[0].name
          }
        }
      } catch (e) {
        // 请求失败时保留页面内置的 mock 数据兜底
        console.error('获取今日菜品失败：', e)
      }
    },
    // 根据当前时间返回默认餐次：5-9 点早餐，10-14 点午餐，16-21 点晚餐
    getDefaultMeal() {
      const hour = new Date().getHours()
      if (hour >= 5 && hour < 10) return '早餐'
      if (hour >= 10 && hour < 15) return '午餐'
      if (hour >= 16 && hour < 22) return '晚餐'
      return ''
    },
    handleStallChange() {
      if (this.stallName) sessionStorage.setItem('stall_name', this.stallName)
      this.$message.success(`已切换到 ${this.stallName}`)
      // 切换档口后刷新菜品
      this.getTodayDishesData()
    },
    handleMealChange(val) {
      const target = this.mealList.find((m) => m.name === val)
      this.mealTime = (target && target.time) || ''
      if (val) sessionStorage.setItem('meal_name', val)
      this.$message.success(`已切换到 ${val}`)
      // 切换餐次后刷新菜品
      this.getTodayDishesData()
    },
    handleLogout() {
      this.$confirm('确定退出登录吗？', '退出提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 退出时清空本地存储
          sessionStorage.removeItem('token')
          sessionStorage.removeItem('shop_id')
          sessionStorage.removeItem('stall_name')
          sessionStorage.removeItem('meal_name')
          this.$router.replace('/loginMenu')
        })
        .catch(() => {})
    },
    selectDish(index) {
      this.selectedDishIndex = index
      // 同步当前选中菜品名称
      const dish = this.dishList[index]
      if (dish) {
        this.selectedDishName = dish.name
      }
    },
    adjustSold(value) {
      const dish = this.dishList[this.selectedDishIndex]
      const count = Math.abs(value)
      const newSold = dish.sold + count
      if (newSold > dish.total) {
        this.$message.warning('已售数量不能超过总数量')
        return
      }
      // 调用后端接口：count 为本次增加的售卖数量
      const params = {
        shop_id: sessionStorage.getItem('shop_id') || null,
        stall_name: this.stallName || null,
        meal_name: this.mealName || null,
        dish_name: this.selectedDishName || dish.name,
        date: this.currentDate
      }
      sellDish({ count, ...params })
        .then((res) => {
          console.log(res, 'sellDish')
          dish.sold = newSold
          dish.remaining = dish.total - newSold
          this.$message.success(`"${dish.name}" 已售数量调整为 ${dish.sold}`)
        })
        .catch(() => {
          this.$message.error('设置失败，请重试')
        })
    },
    setRemaining(value) {
      const dish = this.dishList[this.selectedDishIndex]
      // 数值校验
      if (typeof value === 'number' && (value > dish.total || value < 0)) {
        this.$message.warning('剩余数量不能超过总数量或小于 0')
        return
      }
      // 'restore' 表示恢复为总数量，数值表示恢复为指定数量
      const remaining = value === 'restore' ? dish.total : value
      const params = {
        shop_id: sessionStorage.getItem('shop_id') || null,
        stall_name: this.stallName || null,
        meal_name: this.mealName || null,
        dish_name: this.selectedDishName || dish.name,
        date: this.currentDate,
        remaining_quantity: remaining
      }
      restoreDish(params)
        .then((res) => {
          console.log(res, 'restoreDish')
          dish.remaining = remaining
          dish.sold = dish.total - remaining
          dish.sold_out = remaining > 0 ? 0 : 1
          this.$message.success(
            value === 'restore'
              ? `"${dish.name}" 已恢复初始数量`
              : `"${dish.name}" 剩余数量设置为 ${value}`
          )
        })
        .catch(() => {
          this.$message.error('设置失败，请重试')
        })
    },
    handleSoldOut() {
      const dish = this.dishList[this.selectedDishIndex]
      this.$confirm(`确定将 "${dish.name}" 标记为售罄吗？`, '确认售罄', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            shop_id: sessionStorage.getItem('shop_id') || null,
            stall_name: this.stallName || null,
            meal_name: this.mealName || null,
            dish_name: this.selectedDishName || dish.name,
            date: this.currentDate
          }
          return setSoldOut(params)
        })
        .then((res) => {
          console.log(res, 'setSoldOut')
          dish.sold_out = 1 // 立即触发售罄样式
          dish.sold = dish.total
          dish.remaining = 0
          this.$message.success(`"${dish.name}" 已标记为售罄`)
        })
        .catch(() => {
          this.$message.error('标记售罄失败，请重试')
        })
    },
    handleRefresh() {
      this.$message.info('数据已刷新')
      // 重新请求档口/餐次与今日菜品数据（getStallAndMealData 内部会再拉取菜品），重新渲染页面
      this.getStallAndMealData()
    },
    scrollDishCards(direction) {
      const container = this.$refs.dishCards
      const scrollAmount = 500
      if (direction === 'right') {
        container.scrollLeft += scrollAmount
      } else {
        container.scrollLeft -= scrollAmount
      }
    }
  },
  mounted() {
    // 加载档口和餐次选项
    this.getStallAndMealData()
  }
}
</script>

<style scoped>
.dish-management {
  width: 1920px;
  height: 1080px;
  background: #f0f2f5;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", Arial, sans-serif;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 顶部导航 */
.header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: linear-gradient(135deg, #16213e 0%, #1a1a2e 45%, #16213e 100%);
  color: #fff;
  padding: 0 56px;
  height: 128px;
  flex-shrink: 0;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
  z-index: 5;
}

/* 底部金色装饰线 + 左右光晕 */
.header::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 4px;
  background: linear-gradient(90deg, transparent, #f5a623 20%, #ffd080 50%, #f5a623 80%, transparent);
}

.header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 720px;
  height: 128px;
  background: radial-gradient(ellipse at center top, rgba(245, 166, 35, 0.18), transparent 70%);
  pointer-events: none;
}

.header-left {
  display: flex;
  align-items: center;
}

/* 品牌区 */
.brand {
  display: flex;
  align-items: center;
  gap: 22px;
}

.stall-icon {
  width: 76px;
  height: 76px;
  background: linear-gradient(135deg, #f7b733, #f5a623);
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  color: #fff;
  box-shadow: 0 8px 20px rgba(245, 166, 35, 0.4);
}

.brand-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.header-title {
  font-size: 40px;
  font-weight: 700;
  letter-spacing: 4px;
  line-height: 1.2;
  background: linear-gradient(90deg, #fff, #ffe8bd);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.header-subtitle {
  font-size: 16px;
  letter-spacing: 5px;
  color: rgba(255, 255, 255, 0.45);
  font-weight: 400;
}

/* 中间选择区 */
.header-center {
  display: flex;
  align-items: center;
}

.header-selects {
  display: flex;
  align-items: center;
  gap: 28px;
}

.select-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.select-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 24px;
  color: rgba(255, 255, 255, 0.7);
  white-space: nowrap;
}

.select-label i {
  color: #f5a623;
}

.header-select {
  width: 250px;
}

.header-select ::v-deep .el-input__inner {
  height: 54px;
  line-height: 54px;
  font-size: 24px;
  color: #fff;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 12px;
  transition: all 0.25s ease;
}

.header-select ::v-deep .el-input__inner:hover {
  border-color: rgba(245, 166, 35, 0.6);
  background: rgba(255, 255, 255, 0.12);
}

.header-select ::v-deep .el-input__inner:focus {
  border-color: #f5a623;
  background: rgba(245, 166, 35, 0.12);
  box-shadow: 0 0 0 3px rgba(245, 166, 35, 0.15);
}

.header-select ::v-deep .el-input__inner::placeholder {
  color: rgba(255, 255, 255, 0.55);
}

.header-select ::v-deep .el-input__suffix {
  color: #fff;
}

.header-select ::v-deep .el-select__caret {
  color: #f5a623;
  font-size: 22px;
}

/* 右侧信息与操作区 */
.header-right {
  display: flex;
  align-items: center;
  gap: 32px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 24px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 12px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 24px;
  color: rgba(255, 255, 255, 0.9);
  white-space: nowrap;
}

.info-item i {
  color: #f5a623;
}

.info-item.meal {
  padding-left: 14px;
  border-left: 1px solid rgba(255, 255, 255, 0.16);
  color: #ffd080;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-btn {
  color: rgba(255, 255, 255, 0.75) !important;
  font-size: 28px;
  padding: 12px 26px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.18) !important;
  transition: all 0.25s ease;
}

.header-btn:hover {
  color: #fff !important;
  background: rgba(255, 255, 255, 0.18);
  border-color: rgba(255, 255, 255, 0.35) !important;
  transform: translateY(-1px);
}

.header-btn i {
  margin-right: 6px;
  font-size: 30px;
}

/* 退出按钮：与普通按钮区分，偏红色 */
.header-btn.logout-btn {
  color: #ffb3b3 !important;
  background: rgba(245, 108, 108, 0.12);
  border-color: rgba(245, 108, 108, 0.4) !important;
}

.header-btn.logout-btn:hover {
  color: #fff !important;
  background: rgba(245, 108, 108, 0.75);
  border-color: rgba(245, 108, 108, 0.9) !important;
}

/* 菜品卡片区域（菜品多时可左右滚动显示） */
.dish-cards-wrapper {
  position: relative;
  background: #fff;
  margin: 24px 48px;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}

.dish-cards {
  display: flex;
  gap: 24px;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 4px 56px;
  scrollbar-width: none;
}

.dish-cards::-webkit-scrollbar {
  display: none;
}

.dish-card {
  display: flex;
  align-items: center;
  gap: 22px;
  min-width: 460px;
  padding: 20px 28px;
  border: 2px solid #e8e8e8;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.25s ease;
}

.dish-card:hover {
  border-color: #409eff;
}

.dish-card.active {
  border-color: #409eff;
  background: #f0f7ff;
}

.dish-img {
  position: relative;
  flex-shrink: 0;
}

.dish-img img {
  width: 104px;
  height: 104px;
  border-radius: 12px;
  object-fit: cover;
}

/* 售罄遮罩：盖在菜品图上 */
.sold-out-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  background: rgba(21, 87, 48, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.sold-out-text {
  font-size: 24px;
  font-weight: 900;
  color: #ffffff;
  background: #e43c2a;
  padding: 6px 18px;
  border-radius: 10px;
  letter-spacing: 4px;
  transform: rotate(-8deg);
  box-shadow: 0 4px 12px rgba(228, 60, 42, 0.45);
}

/* 售罄卡片整体置灰 */
.dish-card.sold-out {
  border-color: #f0caca;
  background: #fdf6f6;
}

.dish-card.sold-out .dish-img img {
  filter: grayscale(0.8);
}

.dish-card.sold-out .dish-name {
  color: #b5b5b5;
}

.dish-card.sold-out .stat-value,
.dish-card.sold-out .stat-label {
  color: #c0c4cc;
}

/* 菜名旁的"已售罄"小标签 */
.sold-out-tag {
  display: inline-block;
  margin-left: 10px;
  font-size: 20px;
  font-weight: 600;
  color: #e43c2a;
  background: rgba(228, 60, 42, 0.08);
  border: 1px solid #e43c2a;
  border-radius: 6px;
  padding: 2px 10px;
  vertical-align: 4px;
}

.dish-info {
  flex: 1;
}

.dish-name {
  font-size: 26px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
}

.dish-stats {
  display: flex;
  gap: 40px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stat-value {
  font-size: 34px;
  font-weight: 700;
  color: #303133;
}

.stat-value.sold {
  color: #409eff;
}

.stat-value.remaining {
  color: #67c23a;
}

.stat-label {
  font-size: 18px;
  color: #909399;
  margin-top: 4px;
}

/* 滚动箭头 */
.scroll-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 52px;
  height: 52px;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.2s;
  font-size: 24px;
}

.scroll-arrow:hover {
  border-color: #409eff;
  color: #409eff;
}

.scroll-arrow.left {
  left: 8px;
}

.scroll-arrow.right {
  right: 8px;
}

/* 调整区域 */
.adjust-section {
  display: flex;
  gap: 24px;
  margin: 0 48px 24px;
  flex: 1;
  min-height: 0;
}

.adjust-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  padding: 28px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  min-height: 0;
}

.panel-title {
  font-size: 26px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 24px;
}

.buttons-grid-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-height: 0;
}

.buttons-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  overflow-x: auto;
  padding: 4px 0;
  flex: 1;
  align-content: flex-start;
}

.buttons-grid::-webkit-scrollbar {
  display: none;
}

.adjust-btn {
  min-width: 120px;
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 30px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
  border: 2px solid;
  flex: 1 1 120px;
}

.sold-btn {
  color: #409eff;
  border-color: #b3d8ff;
  background: #fff;
}

.sold-btn:hover {
  background: #ecf5ff;
  border-color: #409eff;
}

.sold-btn:active {
  background: #409eff;
  color: #fff;
}

/* 售罄时调整已售按钮禁用态 */
.adjust-btn.sold-btn.is-disabled,
.adjust-btn.sold-btn.is-disabled:hover,
.adjust-btn.sold-btn.is-disabled:active {
  color: #c0c4cc;
  background: #f5f7fa;
  border-color: #e4e7ed;
  box-shadow: none;
  cursor: not-allowed;
  transform: none;
}

.remain-btn {
  color: #67c23a;
  border-color: #c2e7b0;
  background: #fff;
}

.remain-btn:hover {
  background: #f0f9eb;
  border-color: #67c23a;
}

.remain-btn:active {
  background: #67c23a;
  color: #fff;
}

/* 底部操作栏 */
.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  margin: 0 48px 40px;
  padding: 20px 40px;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
}

.footer-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tip-icon {
  font-size: 30px;
}

.tip-label {
  font-size: 22px;
  font-weight: 600;
  color: #f5a623;
}

.tip-text {
  font-size: 20px;
  color: #909399;
}

.footer-right {
  display: flex;
  gap: 12px;
}

.sold-out-btn {
  padding: 14px 48px;
  font-size: 24px;
  font-weight: 600;
  border-radius: 10px;
  letter-spacing: 2px;
}

.sold-out-btn i {
  margin-right: 4px;
}

/* 适配说明 */
/* 页面固定以 1920x1080 设计稿渲染，由外层 v-scale-screen 组件自动等比缩放适配各分辨率屏幕 */
</style>
